"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueAsset = void 0;
var Issue_ItemRecord_1 = require("./Issue_ItemRecord");
var Transaction_1 = require("./Transaction");
var IssueAsset = /** @class */ (function (_super) {
    __extends(IssueAsset, _super);
    function IssueAsset(creator, asset, feePow, timestamp, reference, port, genesis_sign) {
        return _super.call(this, new Int8Array([IssueAsset.TYPE_ID, 0, 0, 0]), IssueAsset.NAME_ID, creator, asset, feePow, timestamp, reference, port, genesis_sign) || this;
    }
    IssueAsset.TYPE_ID = Transaction_1.Transaction.ISSUE_ASSET_TRANSACTION;
    IssueAsset.NAME_ID = 'Issue Asset';
    return IssueAsset;
}(Issue_ItemRecord_1.Issue_ItemRecord));
exports.IssueAsset = IssueAsset;
